import http from "./httpService";
import { getConfig } from "../config/config.js";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/public/noticias";

// Trae una página de noticias públicas (más nuevas primero). Devuelve el objeto
// completo { records, total, hasMore } para el scroll infinito; ante error de
// red devuelve el string "NETWORK ERROR" (misma convención que los demás
// servicios), y ante cualquier otro error un objeto vacío seguro.
export async function getNoticiasPublic(skip = 0, limit = 5) {
  try {
    const response = await http.get(serviceEndpoint + "?skip=" + skip + "&limit=" + limit);
    return response.data;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return "NETWORK ERROR";
    else return { records: [], hasMore: false };
  }
}

export async function getNoticiaPublic(id) {
  try {
    const response = await http.get(serviceEndpoint + "/" + id);
    return response.data.record;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return "NETWORK ERROR";
    else return null;
  }
}
